export const StepsData = [
  {
    title: "Conosciamoci",
    destination: "/user-data"
  },
  {
    title: "SDG",
    destination: "/areas"
  },
  {
    title: "Contributi",
    destination: "/contributions"
  },
  {
    title: "Protezione",
    destination: "/extra-protections"
  },
  {
    title: "Scenario",
    destination: "/scenario"
  },
  {
    title: "Riepilogo",
    destination: "/summary"
  }
];
